import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { logError } from '@jwp/ott-common/src/logger';
import { useNavigate, Navigate } from 'react-router';

import useQueryParam from '../../../hooks/useQueryParam';

import ResetPasswordChallenge from './challenges/ResetPasswordChallenge';

const AuthChallenge = () => {
  const id = useQueryParam('id');
  const navigate = useNavigate();
  const { challenge, data = {} } = useAccountStore((state) => state.getChallenge(id || '')) || {};

  if (!challenge) {
    logError('AuthChallenge', 'Auth challenge modal closed because there is no challenge');
    navigate({ search: '' });
    return null;
  }

  switch (challenge.type) {
    case 'NEW_PASSWORD_REQUIRED':
      if (typeof data['email'] === 'string') return <ResetPasswordChallenge email={data['email']} />;
      logError('AuthChallenge', 'Auth challenge modal closed because the user email is missing');
      return <Navigate to={{ search: '' }} />;
    default:
      logError('AuthChallenge', `Auth challenge modal closed because the challenge ${challenge.type} is not supported`);
      return <Navigate to={{ search: '' }} />;
  }
};

export default AuthChallenge;
